
angular.module('bmsApp.directives').factory('ComplaintSvc', [
	'$rootScope',
	'$modal',
	'notify',
	'CRUDSvc',
	'COMPLAINT_API', function (
		$rootScope,
		$modal,
		notify,
		CRUDSvc,
		COMPLAINT_API) {

	return {
		complaintTypeOptions: function () {
			return CRUDSvc.get(COMPLAINT_API.COMPLAINT_TYPE_OPTIONS);
		},
		complaintStatusOptions: function () {
			return CRUDSvc.get(COMPLAINT_API.COMPLAINT_STATUS_OPTIONS);
		},
		index: function (params) {
			return CRUDSvc.get(COMPLAINT_API.INDEX, params);
		},
		indexByObject: function (params) {
			return CRUDSvc.post(COMPLAINT_API.INDEX_BY_OBJECT, params);
		},
		count: function (params) {
			return CRUDSvc.get(COMPLAINT_API.COUNT, params);
		},
		alertCount: function () {
			return CRUDSvc.get(COMPLAINT_API.ALERT_COUNT);
		},
		create: function (complaint) {
			return CRUDSvc.post(COMPLAINT_API.CREATE, complaint);
		},
		update: function (complaint) {
			return CRUDSvc.post(COMPLAINT_API.UPDATE + complaint.id, complaint);
		},
		delete: function (complaint) {
			return CRUDSvc.get(COMPLAINT_API.DELETE + complaint.id);
		},
		showSaveModal: function (complaint, viewOnly = false) {
			var modalInstance = $modal.open({
				animation: true,
				templateUrl: 'ng/complaints/templates/ComplaintForm.html',
				controller: 'ComplaintFormCtrl',
				size: 'lg',
				scope: $rootScope,
				backdrop: 'static', // disable click-outside closing modal
				resolve: {
					complaint: function () {
						return angular.copy(complaint);
					},
					viewOnly: function (){
						return viewOnly;
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (result.success === true) {
					var message;
					switch (result.action) {
						case 'create':
							message = 'Complaint created successfully';
							break;
						case 'update':
							message = 'Complaint updated successfully';
							break;
						default:
							message = 'Success';
							break;
					}
					notify({
						message: message
					});
					$rootScope.$broadcast('complaintsUpdated');
				}
				else {
					notify({
						message: result.error,
						classes: 'error'
					});
				}
			}, function () {
				// closed
			});
		}
	};

}]).constant('COMPLAINT_API', {
	COMPLAINT_TYPE_OPTIONS: 'api/complaintType/options',
	COMPLAINT_STATUS_OPTIONS: 'api/complaintStatus/options',
	INDEX: 'api/complaint/index',
	INDEX_BY_OBJECT: 'api/complaint/indexByObject',
	COUNT: 'api/complaint/count',
	ALERT_COUNT: 'api/complaint/alert-count',
	CREATE: 'api/complaint/create',
	UPDATE: 'api/complaint/update/',
	DELETE: 'api/complaint/delete/'
});
